
import React, {memo} from "react";
import useViewport from "components/general/useViewPort";
import Competitor from "components/presentation/Competitor";

const TableExpanded = memo((props) => {
    const { breakPoint } = useViewport();
    const isMobile = breakPoint === "sm" || breakPoint === "xs" 
    const {row} = props;
console.log(row)
    const names = row?.teamAthletes?.map(ath => {
        return (<tr key={ath?.athlete?.code}>
            <td className="w-20"></td>
            <td className="text-start w-30"><Competitor {...ath?.athlete} hideNoc={true} hidePicture={true}/></td>
            <td className="text-start">{ath?.athlete?.personGender?.description}</td>
        </tr>     )
    })

    const xl = (
        <table className="w-100">
            <tbody>
                {names}       
            </tbody>
        </table>
    );
    
    return <>{isMobile ? xl : xl}</>

}, () => {
    return true;
});


export default TableExpanded;
